/** Bot / assistant avatar (header, intro, launcher) */
export const GEOFLEET_BOT_AVATAR_URL = 'https://cdn.geofleet.ai/favicon.ico';

/** Calendly used when API does not supply a demo URL */
export const DEMO_CALENDLY_URL = 'https://calendly.com/aditya-geofleet/30min';

/** Calendly pages need `embed=true` to load reliably inside an iframe. */
export function calendlyEmbedUrl(calendlyPageUrl: string): string {
  const t = calendlyPageUrl.trim();
  if (!t) return t;
  try {
    const u = new URL(t);
    if (!u.hostname.toLowerCase().includes('calendly.com')) return t;
    u.searchParams.set('embed', 'true');
    return u.toString();
  } catch {
    const join = t.includes('?') ? '&' : '?';
    return `${t}${join}embed=true`;
  }
}

export const SIGNUP_URL = 'https://app.geofleet.ai/signup';

/** Persisted transcript (same device) */
export const MESSAGES_STORAGE_KEY = 'geofleet_public_chat_messages_v1';

/** Client session id for public chat API; cleared with “Clear chat”. */
export const PUBLIC_CHAT_SESSION_ID_KEY = 'geofleet_public_chat_session_id';

/** Once set for the tab session, the nudge bubble is not shown again (per tab) */
export const NUDGE_SESSION_KEY = 'geofleet_chat_nudge_shown_v1';

/**
 * After this many ms on the page, show a small nudge bubble above the launcher. The panel itself
 * never opens on its own: auto-opening covered the homepage hero and product screenshot.
 */
export const CHAT_NUDGE_DELAY_MS = 8000;

export const NUDGE_TEXT = 'Questions about routing or pricing?';

export const NUDGE_CTA = 'Ask Geofleet AI';

export const INTRO_HEADLINE = 'Routing, Fleets & pricing';

export const INTRO_SUBLINE = 'How can we help?';

export const WELCOME_TEXT =
  "👋 Hey — you're speaking with Geofleet AI. To help me give the best answer, share a bit of detail about your fleet, deliveries, or what you're trying to solve.";

export const ERROR_FALLBACK =
  'Something went wrong, please try again.';

/** Minimum time to show the typing indicator (feels less abrupt once the API is fast) */
export const MIN_TYPING_MS = 480;
